import {
  Button,
  Chip,
  Divider,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { EventBusyOutlined, Search, Tune } from "@material-ui/icons";
import { ptBR } from "date-fns/locale";
import { memo } from "react";
import { DateRangePicker, END_DATE, START_DATE } from "react-nice-dates";
import "react-nice-dates/build/style.css";
import SwitchERP from "../../../../components/basics/Switch";
import Card from "../../../../components/cards/Card";
import {
  groupOptions,
  movimentsTypes,
  periods,
  reportTypes,
} from "../../constants";
import { useFluxoDeCaixaService } from "../contexts";
import "../styles/style.css";
import FinanceChip from "./FinanceChip";
import FinanceGroupDrawer from "./FinanceGroupDrawer";
import SelectFilter from "./SelectFilter";

const Filter = () => {
  const {
    cachedCompanies,
    cachedFinanceCategories,
    financeCategoriesFilter,
    setCachedFinanceCategories,
    filters,
    setPeriod,
    setMoviment,
    setShowPreviousBalance,
    filterPeriod,
    groupByFinanceCategory,
    setCustomDatePeriod,
    setReportType,
    setGroupBy,
    applyFinanceFilter,
    refreshCashFlow,
    setSelectedCompany,
    loadingCompanies,
    setDrawerOpen,
    setShowNotPayedAccounts,
    setShowNotReceivedTitles,
  } = useFluxoDeCaixaService();

  return (
    <Grid item xs>
      <Grid
        item
        container
        component={Card}
        direction={"column"}
        style={{
          gap: 24,
          borderLeft: "6px solid #d6e5ff",
          boxSizing: "border-box",
        }}
      >
        <FinanceGroupDrawer />
        <Grid item container xs style={{ gap: 16 }}>
          <Grid item xs>
            <SelectFilter
              filterMatch={filters.multicompany}
              filterOptions={cachedCompanies}
              setFilter={setSelectedCompany}
              label="Empresa"
              loading={loadingCompanies}
            />
          </Grid>
          <Grid item xs>
            <SelectFilter
              label="Movimentação"
              filterOptions={movimentsTypes}
              setFilter={setMoviment}
              filterMatch={filters.moviment}
            />
          </Grid>
          <Grid item xs>
            <SelectFilter
              label="Tipo"
              filterMatch={filters.reportType}
              filterOptions={reportTypes}
              setFilter={setReportType}
            />
          </Grid>
          <Grid item xs>
            <SelectFilter
              label="Agrupamento"
              filterMatch={filters.group}
              filterOptions={groupOptions}
              setFilter={setGroupBy}
            />
          </Grid>
        </Grid>
        <Grid item container xs style={{ gap: 8 }}>
          <Grid item xs={2}>
            <SelectFilter
              label="Periodo de busca"
              filterMatch={filters.period}
              filterOptions={periods}
              setFilter={setPeriod}
            />
          </Grid>
          {filters.period === "custom" && (
            <Grid item xs={4}>
              <DateRangePicker
                startDate={filterPeriod.startDate}
                endDate={filterPeriod.endDate}
                onStartDateChange={(newDate) => {
                  setCustomDatePeriod({
                    startDate: newDate,
                  });
                }}
                onEndDateChange={(newDate) => {
                  setCustomDatePeriod({
                    endDate: newDate,
                  });
                }}
                minimumLength={0}
                format="dd/MM/yyyy"
                weekdayFormat="EEEEE"
                locale={ptBR}
                maximumLength={365}
              >
                {({ startDateInputProps, endDateInputProps, focus }) => (
                  <div
                    className="date-range"
                    style={{
                      display: "flex",
                      gap: 16,
                    }}
                  >
                    <TextField
                      size="small"
                      label="Data inicial"
                      className={
                        "input" + (focus === START_DATE ? " -focused" : "")
                      }
                      {...startDateInputProps}
                      placeholder="Ex: 01/12/2022"
                    />
                    <TextField
                      size="small"
                      label="Data final"
                      className={
                        "input" + (focus === END_DATE ? " -focused" : "")
                      }
                      {...endDateInputProps}
                      placeholder="Ex: 31/12/2022"
                    />
                    <Tooltip title="Limpar filtro de datas">
                      <IconButton
                        size="small"
                        onClick={() =>
                          setCustomDatePeriod({
                            startDate: undefined,
                            endDate: undefined,
                          })
                        }
                        style={{
                          color: "red",
                        }}
                      >
                        <EventBusyOutlined />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
              </DateRangePicker>
            </Grid>
          )}
          <Grid item xs />
          <Grid
            item
            style={{
              alignItems: "center",
              display: "flex",
              marginRight: 16,
            }}
          >
            <SwitchERP
              label={`Exibir Saldo Anterior`}
              labelPlacement="start"
              value={filters.showPreviousBalance}
              onChange={(event) => setShowPreviousBalance(event.target.checked)}
            />
          </Grid>
          <Grid
            item
            style={{
              alignItems: "center",
              display: "flex",
              marginRight: 16,
            }}
          >
            <SwitchERP
              label={`Exibir Contas não pagas`}
              labelPlacement="start"
              value={filters.showNotPayedAccounts}
              onChange={(event) =>
                setShowNotPayedAccounts(event.target.checked)
              }
            />
          </Grid>
          <Grid
            item
            style={{
              alignItems: "center",
              display: "flex",
              marginRight: 16,
            }}
          >
            <SwitchERP
              label={`Exibir Títulos não recebidos`}
              labelPlacement="start"
              value={filters.showNotReceivedTitles}
              onChange={(event) =>
                setShowNotReceivedTitles(event.target.checked)
              }
            />
          </Grid>
        </Grid>
        {filters.useFinanceCategories && (
          <>
            <Grid
              item
              xs
              style={{
                alignItems: "center",
                display: "flex",
                flexWrap: "wrap",
                gap: 8,
              }}
            >
              <Typography style={{ fontWeight: "bold" }} variant="subtitle2">
                Filtrando as categorias:{" "}
              </Typography>
              {financeCategoriesFilter.filtered.some((a) => a.checked) ? (
                financeCategoriesFilter.filtered
                  .filter((category) => !category.parentId)
                  .map((item) => {
                    return (
                      item.checked && <FinanceChip financeCategory={item} />
                    );
                  })
              ) : (
                <Typography>Exibindo todas as categorias</Typography>
              )}
            </Grid>
            {groupByFinanceCategory && (
              <Grid
                item
                xs
                style={{
                  alignItems: "center",
                  display: "flex",
                  gap: 8,
                }}
              >
                <Typography style={{ fontWeight: "bold" }} variant="subtitle2">
                  Agrupando as categorias:
                </Typography>
                {financeCategoriesFilter.grouped.some((a) => a.checked) ? (
                  financeCategoriesFilter.grouped.map(
                    (item) =>
                      item.checked &&
                      !item.parentId && (
                        <Chip
                          label={item.desc}
                          onDelete={() => {
                            const newList = cachedFinanceCategories.map((c) => {
                              if (c.id === item.id || c.parentId === item.id) {
                                c = { ...c, checked: false };
                              }

                              return c;
                            });

                            setCachedFinanceCategories(newList);
                            applyFinanceFilter(
                              filters.useFinanceCategories,
                              newList
                            );
                          }}
                          color="primary"
                        />
                      )
                  )
                ) : (
                  <Typography>Exibindo todas as categorias</Typography>
                )}
              </Grid>
            )}
          </>
        )}
        <Divider />
        <Grid item xs container direction="row" spacing={2}>
          <Grid item xs>
            <Button
              size="small"
              color="primary"
              variant="contained"
              startIcon={<Search />}
              onClick={async () => {
                await refreshCashFlow();
              }}
            >
              Gerar relatório
            </Button>
          </Grid>
          <Grid item>
            <Button
              startIcon={<Tune />}
              color="primary"
              variant="outlined"
              size="small"
              onClick={() => setDrawerOpen(true)}
            >
              Categorias do Financeiro
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(Filter);
